import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "../App.css";
import "../index.css";
import Table from "react-bootstrap/Table";

const Detail = () => {
  const { IdMachine } = useParams();
  const [data, setData] = useState(null);
  const [statistics, setStatistics] = useState(null);
  const [stations, setStations] = useState([]);
  const [lastData, setLastData] = useState(null);
  const [monthlyValues, setMonthlyValues] = useState(null);

  let filteredMonthlyValues = monthlyValues
    ? monthlyValues.filter((item) => item.IdMachine === IdMachine)
    : [];
  let filterDailyValues = statistics
    ? statistics.filter((item) => item.IdMachine === IdMachine)
    : [];

  const now = new Date();
  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(now.getDate() - 7);

  let filteredDailyValues = filterDailyValues.filter((item) => {
    const itemDate = new Date(item.Date);
    return itemDate >= sevenDaysAgo;
  });

  console.log(filteredDailyValues);
  console.log(filteredMonthlyValues);

  const station =
    stations.length > 0
      ? stations.find((station) => station.id === IdMachine)
      : null;

  useEffect(() => {
    fetch(`https://test.visiontronic.cz/device.php?IdMachine=${IdMachine}`)
      .then((response) => {
        return response.json();
      })
      .then((data) => setData(data))
      .catch((error) => console.error(error));
  }, [IdMachine]);

  useEffect(() => {
    fetch(`https://test.visiontronic.cz/last.php?IdMachine=${IdMachine}`)
      .then((response) => {
        return response.json();
      })
      .then((data) => setLastData(data))
      .catch((error) => console.error(error));
  }, [IdMachine]);

  useEffect(() => {
    fetch(`https://test.visiontronic.cz/statistics.php`)
      .then((response) => response.json())
      .then((data) => setStatistics(data))
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    fetch(`https://test.visiontronic.cz/stations.php`)
      .then((response) => response.json())
      .then((data) => setStations(data))
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    fetch(`https://test.visiontronic.cz/MonthlyValues.php`)
      .then((response) => response.json())
      .then((data) => setMonthlyValues(data))
      .catch((error) => console.error(error));
  }, []);

  if (!data || !statistics || !stations || !lastData || !monthlyValues) {
    return <div>Loading...</div>;
  }

  return (
    <div className="detail-body">
      <div className="detail-container">
        <div className="card">
          <h2>{data[0].StationName}</h2>
          <div className="paragrap">
            <div className="inner-paragraph">
              <p className="inner-paragraph-title">Dnes</p>
              <p>
                Tržba CZK:{" "}
                {new Intl.NumberFormat("cs-CZ", {
                  style: "currency",
                  currency: "CZK",
                }).format(data[0].Cash_Kc)}
              </p>
              <p>
                Tržba EUR:{" "}
                {new Intl.NumberFormat("de-DE", {
                  style: "currency",
                  currency: "EUR",
                }).format(data[0].Cash_Eur)}
              </p>
              <p>
                Tržba terminál:{" "}
                {new Intl.NumberFormat("cs-CZ", {
                  style: "currency",
                  currency: "CZK",
                }).format(data[0].Terminal_Kc)}
              </p>
            </div>
            <div className="inner-paragraph">
              <p className="inner-paragraph-title">Celkem</p>
              <p>
                Tržby CZK:{" "}
                {new Intl.NumberFormat("cs-CZ", {
                  style: "currency",
                  currency: "CZK",
                }).format(lastData.SumCashKc)}
              </p>
              <p>
                Tržby EUR:{" "}
                {new Intl.NumberFormat("de-DE", {
                  style: "currency",
                  currency: "EUR",
                }).format(lastData.SumCashEur)}
              </p>
              <p>
                Tržby terminál:{" "}
                {new Intl.NumberFormat("cs-CZ", {
                  style: "currency",
                  currency: "CZK",
                }).format(lastData.SumCard)}
              </p>
            </div>
            <p style={{ color: "lightgray", fontSize: "small" }}>
              Aktualizováno:{" "}
              {new Date(data[0].LastTimeStamp).toLocaleString("cs-CZ")}
            </p>
          </div>
        </div>
        <div>
          <div className="card">
            <h3>{station["coin 1"]}</h3>
            <div className="paragrap">
              <p>Dnes prodáno: {data[0].Hopper_Total_OUT1} ks</p>
              <p>Celkem prodáno: {lastData.Hopper1Out} ks</p>
              <p>
                Cena mince:{" "}
                {new Intl.NumberFormat("cs-CZ", {
                  style: "currency",
                  currency: "CZK",
                }).format(station["price coin"])}
              </p>
            </div>
          </div>
          {data[0].TypeMachine == 2 && (
            <div className="card">
              <h3>{station["coin 2"]}</h3>
              <div className="paragrap">
                <p>Dnes prodáno: {data[0].Hopper_Total_OUT1} ks</p>
                <p>Celkem prodáno: {lastData.Hopper2Out}</p>
                <p>
                  Cena mince:{" "}
                  {new Intl.NumberFormat("cs-CZ", {
                    style: "currency",
                    currency: "CZK",
                  }).format(station["price coin"])}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="chart-container center">
        <div className="card table">
          <h3>Měsiční statistika</h3>
          <div>
            <Table striped bordered hover className="w-100">
              <thead>
                <tr>
                  <th style={{ width: "20%", padding: "0 10px" }}>Měsíc</th>
                  <th style={{ width: "20%", padding: "0 10px" }}>
                    Počet mincí
                  </th>
                  <th style={{ width: "20%", padding: "0 10px" }}>Terminál</th>
                  <th style={{ width: "20%", padding: "0 10px" }}>CZK</th>
                  <th style={{ width: "20%", padding: "0 10px" }}>EUR</th>
                </tr>
              </thead>
              <tbody>
                {filteredMonthlyValues.map((row, index) => (
                  <tr key={index}>
                    <td style={{ width: "20%", padding: "0 10px" }}>
                      {row.Month}
                    </td>
                    <td style={{ width: "20%", padding: "0 10px" }}>
                      {row.TotalHopper1Out}
                    </td>
                    <td style={{ width: "20%", padding: "0 10px" }}>
                      {new Intl.NumberFormat("cs-CZ", {
                        style: "currency",
                        currency: "CZK",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format(row.TotalSumCard)}
                    </td>
                    <td style={{ width: "20%", padding: "0 10px" }}>
                      {new Intl.NumberFormat("cs-CZ", {
                        style: "currency",
                        currency: "CZK",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format(row.TotalSumCashKc)}
                    </td>
                    <td style={{ width: "20%", padding: "0 10px" }}>
                      {new Intl.NumberFormat("de-DE", {
                        style: "currency",
                        currency: "EUR",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format(row.TotalSumCashEur)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
        <div className="card table">
          <h3>Prodeje za posledních 7 dní</h3>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Den</th>
                <th>Počet mincí</th>
                <th>Terminál</th>
                <th>CZK</th>
                <th>EUR</th>
              </tr>
            </thead>
            <tbody>
              {filteredDailyValues.map((row, index) => (
                <tr key={index}>
                  <td>{row.Date}</td>
                  <td>{row.DailyHopper1Out}</td>
                  <td>
                    {new Intl.NumberFormat("cs-CZ", {
                      style: "currency",
                      currency: "CZK",
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    }).format(row.DailySumCard)}
                  </td>
                  <td>
                    {new Intl.NumberFormat("cs-CZ", {
                      style: "currency",
                      currency: "CZK",
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    }).format(row.DailySumCashKc)}
                  </td>
                  <td>
                    {new Intl.NumberFormat("de-DE", {
                      style: "currency",
                      currency: "EUR",
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    }).format(row.DailySumCashEur)}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default Detail;
